import React, { useEffect, useMemo, useState } from 'react';
import Layout from '../components/Layout';
import { api, STATUT_LABELS, STATUT_COLORS } from '../lib/api';
import SortHeader, { useSort, sortArr } from '../components/SortHeader';
import { Input } from '../components/ui/input';
import { Search } from 'lucide-react';

export default function ProjetsList() {
  const [projets, setProjets] = useState([]);
  const [search, setSearch] = useState('');
  const [sort, toggleSort] = useSort('code', 'desc');

  useEffect(() => { api.get('/projets').then(r => setProjets(r.data)); }, []);

  const filtered = useMemo(() => {
    const s = search.trim().toLowerCase();
    if (!s) return projets;
    return projets.filter(p =>
      p.code.toLowerCase().includes(s) ||
      p.nom.toLowerCase().includes(s) ||
      (p.promoteur_code || '').toLowerCase().includes(s)
    );
  }, [projets, search]);

  const sorted = useMemo(() => sortArr(filtered, sort, (p, k) => {
    if (k === 'statut') return STATUT_LABELS[p.statut] || '';
    return p[k];
  }), [filtered, sort]);

  return (
    <Layout title="Liste des projets" subtitle={`${sorted.length} projet${sorted.length > 1 ? 's' : ''} — Pour la saisie de pointage`}>
      <div className="bg-white border border-zinc-200 p-4 mb-4">
        <div className="relative max-w-md">
          <Search size={14} className="absolute left-3 top-[11px] text-zinc-400" />
          <Input className="rounded-none pl-9" placeholder="Rechercher code, nom, promoteur…" value={search} onChange={(e) => setSearch(e.target.value)} data-testid="projetslist-search" />
        </div>
      </div>
      <div className="bg-white border border-zinc-200 overflow-x-auto" data-testid="projetslist-table">
        <table className="w-full text-sm">
          <thead className="border-b border-zinc-900">
            <tr className="text-left">
              <SortHeader sort={sort} onToggle={toggleSort} k="code" label="Code" />
              <SortHeader sort={sort} onToggle={toggleSort} k="promoteur_code" label="Promo" />
              <SortHeader sort={sort} onToggle={toggleSort} k="nom" label="Nom" />
              <SortHeader sort={sort} onToggle={toggleSort} k="statut" label="Statut" />
            </tr>
          </thead>
          <tbody>
            {sorted.map((p) => (
              <tr key={p.id} className="border-b border-zinc-100 hover:bg-zinc-50">
                <td className="px-3 py-2 font-mono text-xs font-medium text-[#002FA7]">{p.code}</td>
                <td className="px-3 py-2 font-mono text-xs text-zinc-500">{p.promoteur_code || '—'}</td>
                <td className="px-3 py-2 font-medium text-xs">{p.nom}</td>
                <td className="px-3 py-2">
                  <span className={`inline-block px-2 py-0.5 text-[10px] uppercase tracking-wider font-medium border ${STATUT_COLORS[p.statut]}`}>
                    {STATUT_LABELS[p.statut]}
                  </span>
                </td>
              </tr>
            ))}
            {sorted.length === 0 && (
              <tr><td colSpan={4} className="px-4 py-8 text-center text-zinc-500 text-sm">Aucun projet.</td></tr>
            )}
          </tbody>
        </table>
      </div>
    </Layout>
  );
}
